module.exports = __webpack_public_path__ + "static/media/ledsen.1bd711e2.mp3";